import { Box, Typography } from "@mui/material";
import SpinnerWrapper from "@arelia-components/ui-atoms/SpinnerWrapper";
import { ConnectionDto, ConnectionName } from "@arelia-types/connection";
import { CONSTANTS } from "@arelia-utils/constants/constants";
import BasicConnection from "./cards/BasicConnection";
import AreliaAuthConnection from "./cards/AreliaAuthConnection";
import MetaConnection from "./cards/MetaConnection";
import ConnectServiceConnection from "./cards/ConnectServiceConnection";
import GoogleConnection from "./cards/GoogleConnection";
import AuthServiceConnection from "./cards/AuthServiceConnection";
import AddConnection from "./cards/AddConnection/AddConnection";
import { useContext } from "react";
import ConnectionsContext from "./ConnectionsContext";

type Props = {
  loading: boolean;
  error: boolean;
  children: JSX.Element;
};

export default function ConnectionsPresenter({
  loading,
  error,
  children
}: Props) {

  const { viewConnections, connectionsDto } = useContext(ConnectionsContext);

  const renderCard = (conn: ConnectionDto, index: number) => {
    const mapping: { [key: string]: any } = {
      [ConnectionName.arelia]: <AreliaAuthConnection connection={conn} key={index} />,
      [ConnectionName.facebook]: <MetaConnection connection={conn} key={index} />,
      [ConnectionName.instagram]: <MetaConnection connection={conn} key={index} />,
      [ConnectionName.youtube]: <GoogleConnection connection={conn} key={index} />,
      [ConnectionName.square]: <ConnectServiceConnection connection={conn} key={index} />,
      [ConnectionName.tiktok]: <ConnectServiceConnection connection={conn} key={index} />,
      [ConnectionName.shopify]: <ConnectServiceConnection connection={conn} key={index} />,
      [ConnectionName.twitter]: <ConnectServiceConnection connection={conn} key={index} />,
      [ConnectionName.amazon]: <AuthServiceConnection connection={conn} key={index} />,
      [ConnectionName.distrokid]: <AuthServiceConnection connection={conn} key={index} />,
      [ConnectionName.spotify]: <AuthServiceConnection connection={conn} key={index} />,
      [ConnectionName.songtrust]: <AuthServiceConnection connection={conn} key={index} />,
      [ConnectionName.appleMusic]: <AuthServiceConnection connection={conn} key={index} />,
      [ConnectionName.pandora]: <AuthServiceConnection connection={conn} key={index} />,
      [ConnectionName.cdBaby]: <AuthServiceConnection connection={conn} key={index} />,
      [ConnectionName.ascap]: <AuthServiceConnection connection={conn} key={index} />,
    };
    return mapping[conn.name] || <BasicConnection connection={conn} key={index} />;
  }

  return (
    <>
      <SpinnerWrapper loading={loading}>
        {error
          ? <Typography
            variant="subtitle2"
            sx={{
              py: 2,
              fontWeight: 500,
              fontSize: "16px",
            }}
            color="error">
            {CONSTANTS.UI_MESSAGES.UNKNOWN_ERROR}
          </Typography>
          : <Box sx={{ display: "flex", flexDirection: "column", gap: "20px", alignItems: "flex-start" }}>
              {children}
              <Box
                display="grid"
                gridTemplateColumns="repeat(auto-fit, 210px)"
                gap="22px"
                gridAutoFlow="dense"
                width="100%"
              >
                {viewConnections.map((conn, index) => renderCard(conn, index))}
                {viewConnections.length !== connectionsDto.length && <AddConnection />}
              </Box>
            </Box>
        }
      </SpinnerWrapper>
    </>
  );
}
